Shopify.Quiz = {

  api: {

    urls: {

      test: "https://webhooks.mechanic.dev/63174d5d-7e8b-4be7-944a-a389d22999fe",
      setCustomerTags: "https://webhooks.mechanic.dev/f9605913-01e9-4e40-a893-09217c6aa43d",

    },

    calls: {

      setTags: function(options) {

        if (window.themeVariables.customer.loggedIn != true) {
          console.log("SETTAGS ABORT: Customer is not logged in.");
          return;
        }

        var settings;

        if (typeof options != "undefined") {
          settings = options;
        }

        console.log(settings);

        var data = JSON.parse(localStorage.getItem('quizData'));

        const response = setTags();

        async function setTags() {

          const response = await fetch(Shopify.Quiz.api.urls.setCustomerTags, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          })
          .then((response) => {

            if (typeof settings.success == "function") {
              console.log("SetTags — Success");
              settings.success();
            }

          });
        }

      },

      getResults: function(options) {

        var settings;

        if (typeof options != "undefined") {
          settings = options;
        }

        var data = JSON.parse(localStorage.getItem('quizData'));

        console.log(data);

        async function getResults() {

          console.log("getResults");
          console.log(data);

          const response = await fetch(Shopify.Quiz.api.urls.setCustomerTags, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          })
          .then((response) => {
            Shopify.Quiz.functions.goToResults();
          });
        }

      }

    }

  },

  storage: {

    steps: {

      current: 0,
      completed: 0,
      total: 7

    },

    data: null

  },

  elements: {

    quiz: null,
    quizStepContainer: null,
    quizSteps: null,
    progressNavigation: null,
    progressBar: null,
    progressStepsCurrent: null,
    progressStepsT2otal: null

  },

  functions: {

    clearData: function() {

      console.log("clearData");

      Shopify.Quiz.storage.data = null;
      localStorage.removeItem('quizData');

    },

    storeData: function() {

      var tags = Shopify.Quiz.functions.getQuizDataFromUI();

      var data = {};

      data.tags = tags;

      if (typeof CustomerData != "undefined") {
        data.customer = {
          id: CustomerData.id
        };
      }

      Shopify.Quiz.storage.data = data;

      localStorage.setItem('quizData', JSON.stringify(data));

    },

    validateQuizData: function(data) {

      // Basic validation function to check the data array used to submit data
      // to the back-end is well-formed.

      console.log(data);

      if (typeof data != "object") {
        return false;
      }

      if (typeof data.tags != "object") {
        return false;
      }

      if (!Array.isArray(data.tags)) {
        return false;
      }

      if (data.tags.length < 6) {
        return false;
      }

      return true;

    },

    getQuizDataFromUI: function() {

      let tagArray = [];
      let data = {};

      document.querySelectorAll(".quiz-tile--selected").forEach(element => {

        let tile = element;
        let tilesContainer = tile.closest('.quiz-tiles');
        let tiles = tilesContainer.querySelectorAll('.quiz-tile');
        let tag = tile.dataset.tag;

        let tagSplit = tag.split(":");
        let tagCategory = tagSplit[0];
        let tagName = tagSplit[1];

        let tagObject = {
          tag: tag,
          tagCategory: tagCategory,
          tagName: tagName
        };

        tagArray.push(tagObject)

      });

      data = tagArray;

      return data;

    },

    goToResults: function() {
      
      let destination = window.themeVariables.routes.quizResults;

      location.href = destination;

    },

    hideProgressBar: function() {

      if (Shopify.Quiz.elements.progressNavigation.classList.contains("quiz-progress-bar--hidden") == false) {
        Shopify.Quiz.elements.progressNavigation.classList.add("quiz-progress-bar--hidden");
      }

    },

    showProgressBar: function() {

      if (Shopify.Quiz.elements.progressNavigation.classList.contains("quiz-progress-bar--hidden") == true) {
        Shopify.Quiz.elements.progressNavigation.classList.remove("quiz-progress-bar--hidden");
      }

    },

    updateProgressBar: function() {

      var progress = (Shopify.Quiz.storage.steps.current) / Shopify.Quiz.storage.steps.total;

      Shopify.Quiz.elements.progressBar.style.transform = `scaleX(${progress})`;

    },

    updateProgressNumber: function() {

      Shopify.Quiz.elements.progressStepsCurrent.innerText = Shopify.Quiz.storage.steps.current;
      Shopify.Quiz.elements.progressStepsTotal.innerText = Shopify.Quiz.storage.steps.total;

    },

    updateProgress: function() {

      Shopify.Quiz.elements.currentStep = Shopify.Quiz.elements.quizSteps[Shopify.Quiz.storage.steps.current];

      // When progressing in the steps, update the completed steps.
      if (Shopify.Quiz.storage.steps.completed < Shopify.Quiz.storage.steps.current) {
        Shopify.Quiz.storage.steps.completed = Shopify.Quiz.storage.steps.current;
      }

      if (Shopify.Quiz.storage.steps.completed == Shopify.Quiz.storage.steps.current) {
        Shopify.Quiz.elements.quiz.querySelector("[data-quiz-progress-navigation] [data-quiz-progress-button-next]").disabled = true;
      }
      else {
        Shopify.Quiz.elements.quiz.querySelector("[data-quiz-progress-navigation] [data-quiz-progress-button-next]").disabled = false;
      }

      // Scroll to top for usability.
      window.scrollTo(0, 0);

      Shopify.Quiz.functions.updateProgressBar();
      Shopify.Quiz.functions.updateProgressNumber();
      Shopify.Quiz.functions.updateStep();

    },

    updateStep: function() {

      Shopify.Quiz.elements.quizSteps.forEach((element) => {
        element.style.display = "none";
      });

      Shopify.Quiz.elements.currentStep.style.display = "flex";

    },

    addLoadingOverlay: function() {

      var html = `
      <div class="loading-overlay">
        <div class="loading-overlay__inner">
          <span class="loading-overlay__text h3">Please wait...</span>
        </div>
      </div>
      `;

      var div = document.createElement('div');
      div.innerHTML = html.trim();

      Shopify.Quiz.elements.quiz.appendChild(div.firstChild);

    },

    removeLoadingOverlay: function() {

      var overlay = Shopify.Quiz.elements.quiz.querySelector(".loading-overlay");
      var overlayParent = overlay.parentNode;

      overlay.classList.add("loading-overlay--fade-out");

      var timer = setTimeout(function() {
        overlayParent.removeChild(overlay)
        clearTimeout(timer);
      }, 250);

    },

    addEventListeners: function() {

      Shopify.Quiz.elements.quiz.querySelectorAll("[data-quiz-progress-button-next]").forEach(element => {
        element.addEventListener("click", Shopify.Quiz.eventHandlers.onClickNext);
      });

      Shopify.Quiz.elements.quiz.querySelectorAll("[data-quiz-progress-button-previous]").forEach(element => {
        element.addEventListener("click", Shopify.Quiz.eventHandlers.onClickPrevious);
      });

      Shopify.Quiz.elements.quiz.querySelectorAll("[data-quiz-see-results]").forEach(element => {
        element.addEventListener("click", Shopify.Quiz.eventHandlers.onClickSeeResults);
      });

      Shopify.Quiz.elements.quiz.querySelectorAll("[data-tag]").forEach(element => {
        element.addEventListener("click", Shopify.Quiz.eventHandlers.onClickTile);
      });

      Shopify.Quiz.elements.quiz.querySelectorAll("[data-final-step-tile]").forEach(element => {
        element.addEventListener("click", Shopify.Quiz.eventHandlers.onClickFinalStepTile);
      });

      Shopify.Quiz.elements.quiz.querySelectorAll("[data-step-final-skip]").forEach(element => {
        element.addEventListener("click", Shopify.Quiz.eventHandlers.onClickFinalSkip);
      });

      Shopify.Quiz.elements.quiz.querySelectorAll("[data-quiz-clear]").forEach(element => {
        element.addEventListener("click", Shopify.Quiz.eventHandlers.onClickClearResults);
      });
      

    }

  },

  eventHandlers: {

    onClickFinalStepTile: function(e) {

      Shopify.Quiz.functions.storeData();

      if (window.themeVariables.customer.loggedIn == true) {

        Shopify.Quiz.functions.addLoadingOverlay();

        Shopify.Quiz.api.calls.setTags({
          success: function() {
            Shopify.Quiz.functions.goToResults();
          }
        });

      }

    },

    onClickFinalSkip: function(e) {

      Shopify.Quiz.functions.addLoadingOverlay();

      Shopify.Quiz.functions.goToResults();

      /*
      Shopify.Quiz.api.calls.getResults({
        success: function() {
          Shopify.Quiz.functions.goToResults();
        }
      });
      */

    },

    onClickClearResults: function(e) {

      Shopify.Quiz.functions.clearData();

    },

    onClickTile: function(e) {

      let tile = e.currentTarget;
      let tilesContainer = tile.closest('.quiz-tiles');
      let tiles = tilesContainer.querySelectorAll('.quiz-tile');
      let tag = tile.dataset.tag;

      let tagArray = tag.split(":");
      let tagCategory = tagArray[0];
      let tagName = tagArray[1];

      tiles.forEach(e => {
        e.classList.remove("quiz-tile--selected");
      });

      tile.classList.add("quiz-tile--selected");

      Shopify.Quiz.eventHandlers.onClickNext(e);

    },

    onClickPrevious: function(e) {

      if (Shopify.Quiz.storage.steps.current > 0) {
        Shopify.Quiz.storage.steps.current--;
        Shopify.Quiz.functions.updateProgress();
      }

      if (Shopify.Quiz.storage.steps.current == 0) {
        Shopify.Quiz.functions.hideProgressBar();
      }

      window.scrollTo(0, 0);

    },

    onClickSeeResults: function(e) {

      Shopify.Quiz.functions.addLoadingOverlay();

      Shopify.Quiz.functions.goToResults();

      /*
      Shopify.Quiz.api.calls.getResults({
        success: function() {
          Shopify.Quiz.functions.goToResults();
        }
      });
      */

    },

    onClickNext: function(e) {

      if (Shopify.Quiz.storage.steps.current < Shopify.Quiz.storage.steps.total) {
        Shopify.Quiz.storage.steps.current++;
        Shopify.Quiz.functions.updateProgress();
      }

      if (Shopify.Quiz.storage.steps.current > 0) {
        Shopify.Quiz.functions.showProgressBar();
      }

    }

  },

  init: function() {

    Shopify.Quiz.elements.quiz = document.querySelector("[data-quiz]");

    Shopify.Quiz.elements.quizStepContainer = Shopify.Quiz.elements.quiz.querySelector("[data-step-container]");
    Shopify.Quiz.elements.quizSteps = Shopify.Quiz.elements.quizStepContainer.querySelectorAll(".shopify-section");

    Shopify.Quiz.elements.progressNavigation = document.querySelector("[data-quiz-progress-navigation]");
    Shopify.Quiz.elements.progressBar = Shopify.Quiz.elements.progressNavigation.querySelector("[data-quiz-progress-navigation-bar]");

    Shopify.Quiz.elements.progressStepsCurrent = Shopify.Quiz.elements.quiz.querySelector("[data-quiz-progress-steps-current]");
    Shopify.Quiz.elements.progressStepsTotal = Shopify.Quiz.elements.quiz.querySelector("[data-quiz-progress-steps-total]");

    Shopify.Quiz.functions.addEventListeners();

    if (window.themeVariables.customer.loggedIn == true) {
      Shopify.Quiz.storage.steps.total = 6;
    }
    else {
      Shopify.Quiz.storage.steps.total = 7;
    }

    if (typeof CustomerTags != "undefined") {

      console.log("Returning Customer (from customer tags)");

      document.querySelector('#QuizStepIntro-Existing').classList.remove("hidden");
      document.querySelector('#QuizStepIntro-New').classList.add("hidden");

      var data = {};

      data.tags = CustomerTags;

      if (typeof CustomerData != "undefined") {
        data.customer = {
          id: CustomerData.id
        };
      }

      Shopify.Quiz.storage.data = data;

      console.log('Shopify.Quiz.storage.data');
      console.log(Shopify.Quiz.storage.data);

      localStorage.setItem('quizData', JSON.stringify(Shopify.Quiz.storage.data));

    }
    else
    if (localStorage.getItem('quizData') != null) {

      console.log("Returning Customer (from localStorage)");

      document.querySelector('#QuizStepIntro-Existing').classList.remove("hidden");
      document.querySelector('#QuizStepIntro-New').classList.add("hidden");

      var data = JSON.parse(localStorage.getItem('quizData'));

      if ( Shopify.Quiz.functions.validateQuizData(data) == true ) {

        console.log("Valid quiz data from localStorage.");

        Shopify.Quiz.storage.data = localStorage.getItem('quizData');

      }
      else {

        console.log("Invalid quiz data from localStorage. Showing default first step");
        console.log(localStorage.getItem('quizData'));

        // Shopify.Quiz.storage.data = localStorage.removeItem('quizData');

        document.querySelector('#QuizStepIntro-Existing').classList.add("hidden");
        document.querySelector('#QuizStepIntro-New').classList.remove("hidden");

      }

    }
    else {

      console.log("New Customer");

      document.querySelector('#QuizStepIntro-Existing').classList.add("hidden");
      document.querySelector('#QuizStepIntro-New').classList.remove("hidden");

    }

    Shopify.Quiz.functions.updateProgress();

    Shopify.Quiz.elements.quiz.classList.add("quiz--loaded");

  }

}

document.addEventListener("DOMContentLoaded", function(){
  Shopify.Quiz.init();
})
